export enum EAnswerItemType {
  Column,
  Row
}
